var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 34,
    viewBox: "0 0 38 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_2032_20573)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0805 12.3867L0.402344 20.0701L11.7337 14.6168C15.4748 12.8164 19.7758 12.567 23.7001 13.9228L34.7457 17.7392L37.3931 12.9866L24.006 10.1401C19.8903 9.26499 15.5956 10.0741 12.0805 12.3867Z",
    fill: "#FF4619"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6334 10.9697L9.84627 13.3796L5.91705 16.0288C6.0361 13.2312 6.67465 10.6744 7.83269 8.35833C9.15492 5.77685 11.0438 3.73056 13.4994 2.21944C15.9864 0.739814 18.9299 0 22.3299 0C25.5725 0 28.3114 0.64537 30.5466 1.93611C32.8132 3.25833 34.5132 4.89537 35.6466 6.84722C36.741 8.71071 37.3908 10.5881 37.5959 12.4794L30.8239 11.1364C30.6107 10.5644 30.3294 10.0004 29.9799 9.44444C29.2873 8.34259 28.2957 7.42963 27.0049 6.70556C25.7457 6.01296 24.2188 5.66667 22.4244 5.66667C20.3466 5.66667 18.5364 6.17037 16.9938 7.17778C15.5633 8.13142 14.4432 9.39538 13.6334 10.9697ZM8.26873 16.6169L12.4907 14.6625L12.492 14.6594C12.3765 15.4119 12.3188 16.1921 12.3188 17C12.3188 19.1093 12.7123 21.0139 13.4994 22.7139C14.3179 24.4454 15.4827 25.8148 16.9938 26.8222C18.5364 27.8296 20.3466 28.3333 22.4244 28.3333C24.2188 28.3333 25.7457 27.9713 27.0049 27.2472C28.2535 26.5772 29.2222 25.7158 29.9111 24.6628L35.6423 27.113C34.509 29.093 32.8104 30.7275 30.5466 32.0167C28.3114 33.3389 25.5725 34 22.3299 34C18.9299 34 15.9864 33.2444 13.4994 31.7333C11.0438 30.2537 9.15492 28.2231 7.83269 25.6417C6.62457 23.2254 6.02111 20.6486 5.94378 17.7083L8.26873 16.6169ZM5.91108 16.2069L5.91108 16.1811C5.91077 16.19 5.91046 16.1988 5.91016 16.2076L5.91108 16.2069Z",
    fill: "#131313"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_2032_20573",
    x: 0.402344,
    y: 9.7959,
    width: 36.9922,
    height: 10.2744,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.62963
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.951667 0 0 0 0 0.186196 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2032_20573"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarlogo);
export default __webpack_public_path__ + "static/media/sidebarlogo.e6b80a27895e03f1efdca92a0700151d.svg";
export { ForwardRef as ReactComponent };